import classNames from 'classnames';
import { FC } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IValidation } from 'src/types/main';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { MaskedInput } from '~/view/components/Controls/Inputs';
import './style.scss';
import Input from '~/view/components/Controls/InputComponent/Input';

interface IProps {
  title: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  enableTypeSwitch?: boolean;
  noTranslate?: boolean;
  required?: boolean;
  validation?: IValidation;
  className?: string;
  titleClassName?: string;
  inputClassName?: string;
  masked?: boolean;
}

const ConfigRow: FC<IProps> = (props: IProps): JSX.Element => {
  const inputProps = {
    value: props.value,
    onChangeValue: props.onChange,
    placeholder: localeStore.t('Value'),
    validation: props.validation,
    contentClassName: props.inputClassName,
  };

  return (
    <div className={classNames('config-row', [props.className])}>
      <Text
        type={TEXT.ORDER_FIELD}
        text={props.title}
        className={classNames('config-row__title', [props.titleClassName])}
        required={props.required}
        noTranslate={props.noTranslate}
      />
      {props.masked ? <MaskedInput {...inputProps} /> : <Input {...inputProps} />}
    </div>
  );
};

export default ConfigRow;
